// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"BarChartTooltip_tooltip__2VHnj","colorBlock":"BarChartTooltip_colorBlock__38Vr7"};